import { EventDetailsPageProps, EventShowtimePickerPropsFromBe } from '../types'
import React, { useEffect, useState } from 'react'
import { getAllEvents, getEventById, loadAllEvents } from '@vista/omnichannel-components-domain'

import { AddToDataLayer } from '../utils';
import { useRef } from 'react';
import EventDetailsComponent from '../components/eventDetails/EventDetails';
import EventShowtimePickerComponent from '../components/eventShowtimePicker/EventShowtimePickerComponent';

export const EventDetailsPage: React.FC<EventDetailsPageProps> = props => {
    const { EventDetails, EventShowtimePicker } = props

    const [hasEvents, setHasEvents] = useState<boolean>()
    const [hasViewItemFired, setHasViewItemFired] = useState(false)

    const eventShowtimePickerProps: EventShowtimePickerPropsFromBe = {
        siteDropdownMode: true,
        ...EventShowtimePicker
    }

    const showtimePickerRef = useRef<HTMLDivElement>(null)
    const scrollIntoView = () => showtimePickerRef.current.scrollIntoView()
    const eventDetails = getEventById(eventShowtimePickerProps.workflow.entityIds.eventId)

    useEffect(() => {
        (async () => {
            if (!getAllEvents()) {
                await loadAllEvents()
                //force component to remount
                setHasEvents(true)
            }
        })()
    }, [])

    if (eventDetails?.name && !hasViewItemFired) {
        setHasViewItemFired(true)
        AddToDataLayer({
            event: "view_item",
            ecommerce: {
                items: [{
                    item_name: eventDetails.name.text,
                    item_category: "Event",
                }]
            }
        })
    }

    return (
        <>
            <EventDetailsComponent {...EventDetails} scrollIntoView={scrollIntoView} />

            <div ref={showtimePickerRef}>
                <EventShowtimePickerComponent {...eventShowtimePickerProps} />
            </div>
        </>
    )
}

export default EventDetailsPage